import { Routes, Route } from 'react-router-dom';
import { useAccount } from '../../context/account.context';
import CustomerSettings from './pages/customer-settings';

const SettingsRoutes = () => {
  const { user } = useAccount();

  return (
    <Routes>
      <Route path="/" element={<CustomerSettings user={user} />} />
    </Routes>
  );
};

export default SettingsRoutes;
